<template>
<tr class="">
    <th class="sheet-header text-truncate text-capitalize font-weight-regular" style="border-left: 2px solid white">
        <span>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-icon color="grey darken-2" size="13" v-on="on" style="vertical-align: text-bottom">help_outline</v-icon>
                </template>
                <span>
                    <div>
                        <div class="" style="width: max-content">
                            <v-icon size="14" color='green'>done</v-icon> <span class="pl-1">{{ $t('sheet.sheet_components.close_inventory.tooltip.room_open') }}</span>
                        </div>
                        <div class="" style="width: max-content">
                            <v-icon size="14" color='red'>clear</v-icon> <span class="pl-1">{{ $t('sheet.sheet_components.close_inventory.tooltip.room_close') }}</span>
                        </div>
                    </div>
                </span>
            </v-tooltip>
        </span>
        {{ $t('sheet.sheet_components.close_open_sell.title') }}
    </th>
    <template v-for="day in prices">
        <td class="sheet-cell pa-0 text-center ">
            <div class="d-flex justify-space-around align-center">
                <v-progress-circular v-if="loading_date_arrival == day.date" size="12" width="2" indeterminate />
                <v-icon v-else large v-text="day.closed_arrival ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'" :color="day.closed_arrival ? 'red' : 'grey darken-1'" @click="day.closed_arrival = !day.closed_arrival;save_arrival(day)" />

                <v-progress-circular v-if="loading_date_departure == day.date" size="12" width="2" indeterminate />
                <v-icon v-else large v-text="day.closed_departure ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'" :color="day.closed_departure ? 'red' : 'grey darken-1'" @click="day.closed_departure = !day.closed_departure;save_departure(day)" />
            </div>
        </td>
    </template>
</tr>
</template>
<script>
import {
    mapActions
} from 'vuex';
export default {
    props: {
        prices: Object,
        backup_sheet: [Object, Array],
        params: Object
    },
    data() {
        return {
            loading_date_arrival: null,
            loading_date_departure: null
        }
    },
    methods: {
        ...mapActions('alert', ['success', 'error']),

        save_arrival(day) {
            this.loading_date_arrival = day.date;
            let pricing = {};
            pricing[day.room_type_id] = {};
            pricing[day.room_type_id][day.rate_plan_id] = {};
            pricing[day.room_type_id][day.rate_plan_id][day.date] = {
                closed_arrival: day.closed_arrival
            };
            let query_params = {};

            query_params.hotel_id = this.params.hotel_id;
            query_params.date_start = this.params.date_start;
            query_params.date_stop = this.params.date_stop;
            query_params.pricing = pricing;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/sheet';


            this.$axios.post(endpoint, query_params)
                .then(response => {
                    this.success(this.$t('sheet.message_update'));
                    this.backup_sheet.pricing[day.room_type_id][day.rate_plan_id][day.date].closed_arrival = day.closed_arrival;
                })
                .catch(error => {
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                    this.prices[day.date].closed_arrival = this.backup_sheet.pricing[day.room_type_id][day.rate_plan_id][day.date].closed_arrival
                })
                .finally(() => {
                    this.loading_date_arrival = null;
                });
        },

        save_departure(day) {
            this.loading_date_departure = day.date;
            let pricing = {};
            pricing[day.room_type_id] = {};
            pricing[day.room_type_id][day.rate_plan_id] = {};
            pricing[day.room_type_id][day.rate_plan_id][day.date] = {
                closed_departure: day.closed_departure
            };
            let query_params = {};

            query_params.hotel_id = this.params.hotel_id;
            query_params.date_start = this.params.date_start;
            query_params.date_stop = this.params.date_stop;
            query_params.pricing = pricing;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/sheet';


            this.$axios.post(endpoint, query_params)
                .then(response => {
                    this.success(this.$t('sheet.message_update'));
                    this.backup_sheet.pricing[day.room_type_id][day.rate_plan_id][day.date].closed_departure = day.closed_departure;
                })
                .catch(error => {
                    this.prices[day.date].closed_departure = this.backup_sheet.pricing[day.room_type_id][day.rate_plan_id][day.date].closed_departure;
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {
                    this.loading_date_departure = null;
                });
        }

    }
}
</script>
